import { useTranslation } from 'react-i18next'

const Kitchen4 = (props) => {
  const { t } = useTranslation()

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="kitchen4-title"
      {...props}
    >
      <title id="kitchen4-title">{t('antagonists:adoptiveDad:components:background')}</title>
      <defs>
        <clipPath id="kitchen4-a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="kitchen4-b">
          <path
            d="M1858.29 104.74s.19 2.01.39 3.88 3.8 4.33 7.95 7.1c4.16 2.77 6.56 6.32 6.84 9.48.28 3.16.16 44.61-.08 55.75s-.36 37.58.08 43.32c.44 5.74-2.63 7.17-5.62 7.02-3-.14-31.93.79-38.63.47-6.7-.32-5.65-4.42-5.79-7.57-.14-3.15.09-31.76-.1-42.78s.52-43.87 1.86-50.95c1.34-7.08 10.06-16.11 12.63-18.99 2.57-2.88 1.91-4.06 1.91-4.06l18.57-2.69Zm-.46 18.56c-.74.8-.63 7.12-.86 15.11-.24 8-.72 15.12.75 17.34 1.47 2.21 7.9 2.23 8.9-.86 1.01-3.1.58-9.12.72-15.12s.87-12.25-1.27-15.36c-2.14-3.1-6.58-2.89-8.24-1.11Z"
            style={{
              fill: '#4c8f44',
            }}
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(#kitchen4-a)',
        }}
      >
        <path
          style={{
            fill: '#e2edf2',
          }}
          d="M-340.95-165.42h2325.36V966.13H-340.95z"
        />
        <path
          style={{
            fill: '#f0f3f6',
          }}
          d="M-630.79 761.64h2433.77v676.64H-630.79z"
        />
        <path
          style={{
            fill: '#f9f8f8',
          }}
          d="m866.35-139.92.78 976.45 1543.1 2.72-.06-976.12-1543.82-3.05z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#f0d3b6',
          }}
          d="M-438.33 804.61h2433.77v676.64H-438.33z"
        />
        <path
          style={{
            fill: '#e39b52',
          }}
          d="m2339.73 956.76-.8-367.34-1473.25-4.5-1.46 371.25 1475.51.59z"
        />
        <path
          style={{
            fill: '#edbed1',
          }}
          d="m1506.59 612.26.47 307.33 174.05.84V613.95l-174.52-1.69zm362.34 306.91-2.45-303.36-178.07-.88 2.15 306.92 178.37-2.68z"
        />
        <path
          d="M1664.61 626.27c-5.99.52-8.49 5.07-8.04 9 .52 4.59 3.54 7.85 9.02 7.7 5.17-.14 8.9-4.56 7.72-10.03-.98-4.52-4.25-7.06-8.7-6.67Zm41.59.62c-5.99.52-8.49 5.07-8.04 9 .52 4.59 3.54 7.85 9.02 7.7 5.17-.14 8.9-4.56 7.72-10.03-.98-4.52-4.25-7.06-8.7-6.67Z"
          style={{
            fill: '#71ae52',
          }}
        />
        <path
          style={{
            fill: '#fcc11e',
          }}
          d="m893.18 615.63-.45 72.61 273.86 3.76-.44-74.51-272.97-1.86zm-.44 83.51 271.63 3.12.9 66.94-271.64-1.23-.89-68.83zm1.11 77.3 272.07 1.22.45 64.41-273.42-1.23.9-64.4zm.22 73.02-1.31 69.75h274.06l1.07-68.4-273.82-1.35z"
        />
        <path
          d="M1027.99 643.86c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm-2.59 83.08c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm2.93 73.6c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm2.13 76.23c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Z"
          style={{
            fill: '#e2007a',
          }}
        />
        <path
          style={{
            fill: '#d0afce',
          }}
          d="m1194.3 617.17 271.48.7.15 119.53-271.63-1.23v-119zm.4 127.64 271.22.06-.15 89.74-268.7-.22-2.37-89.58zm1.78 99.07-.6 75.93 269.9 1.78v-77.12l-269.3-.59z"
        />
        <path
          d="M1333.77 644.41c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm3.01 126.02c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm-1.06 99.67c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Z"
          style={{
            fill: '#e2007a',
          }}
        />
        <path
          style={{
            fill: '#e39b52',
          }}
          d="m1282.87 382.53-.22-421.42-421.95-2.16.01 421.16 422.16 2.42z"
        />
        <path
          style={{
            fill: '#edbed1',
          }}
          d="m893.77 65.93-3.97 282.14 174.05.94 4.44-281.19-174.52-1.89zm357.9 281.67 6.68-276.35-177.51-1.04-7.54 280.39 178.37-3z"
        />
        <path
          d="M1045.5 320.28c-5.99.52-8.49 5.07-8.04 9 .52 4.59 3.54 7.85 9.02 7.7 5.17-.14 8.9-4.56 7.72-10.03-.98-4.52-4.25-7.06-8.7-6.67Zm52.13-2.5c-5.99.52-8.49 5.07-8.04 9 .52 4.59 3.54 7.85 9.02 7.7 5.17-.14 8.9-4.56 7.72-10.03-.98-4.52-4.25-7.06-8.7-6.67Z"
          style={{
            fill: '#e52d87',
          }}
        />
        <path
          style={{
            fill: '#d9e1e2',
          }}
          d="m910.64 516.94.22 37.54-34.22.24.55-37.54 33.45-.24zm.18-40.88.23 36.71-33.45-.17.16-36.29 33.06-.25zm.73-41.53.22 37.54-34.23.24.56-37.54 33.45-.24zm37.8 81.64.23 37.54-34.23.24.56-37.54 33.44-.24zm.19-40.88.22 36.71-33.44-.17.16-36.29 33.06-.25zm3.66 40.9-.56 37.53 34.22.6-.22-37.54-33.44-.59zm.18-40.88-.55 36.7 33.44.18.16-36.29-33.05-.59zm70.55 41.24.22 37.54-34.22.24.55-37.53 33.45-.25zm.18-40.87.23 36.7-33.45-.17.16-36.29 33.06-.24zm-112.49-82.62.22 36.71-33.44-.17.16-36.29 33.06-.25zm38.71-.77.23 36.71-33.45-.18.16-36.28 33.06-.25zm3.84.02-.55 36.7 33.45.18.16-36.29-33.06-.59zm70.74.37.22 36.7-33.44-.17.16-36.29 33.06-.24zm-74.65 41.08.22 37.54-34.22.24.55-37.54 33.45-.24zm3.84.02-.55 37.53 34.22.6-.22-37.54-33.45-.59zm70.74.36.22 37.54-34.23.24.56-37.53 33.45-.25zM1063.83 516.94l.23 37.54-34.23.24.56-37.54 33.44-.24zm.19-40.88.22 36.71-33.44-.17.16-36.29 33.06-.25zm.72-41.53.22 37.54-34.22.24.55-37.54 33.45-.24zm37.81 81.64.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.22 36.71-33.44-.17.16-36.29 33.06-.25zm3.66 40.9-.56 37.53 34.22.6-.22-37.54-33.44-.59zm.18-40.88-.55 36.7 33.44.18.17-36.29-33.06-.59zm70.55 41.24.23 37.54-34.23.24.56-37.53 33.44-.25zm.19-40.87.22 36.7-33.45-.17.17-36.29 33.06-.24zm-112.5-82.62.23 36.71-33.45-.17.16-36.29 33.06-.25zm38.71-.77.23 36.71-33.45-.18.16-36.28 33.06-.25zm3.85.02-.56 36.7 33.45.18.16-36.29-33.05-.59zm70.73.37.23 36.7-33.45-.17.16-36.29 33.06-.24zm-74.65 41.08.22 37.54-34.22.24.55-37.54 33.45-.24zm3.85.02-.56 37.53 34.22.6-.22-37.54-33.44-.59zm70.73.36.22 37.54-34.22.24.55-37.53 33.45-.25zM1217.03 516.94l.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.22 36.71-33.44-.17.16-36.29 33.06-.25zm.72-41.53.22 37.54-34.22.24.55-37.54 33.45-.24zm37.81 81.64.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.23 36.71-33.45-.17.16-36.29 33.06-.25zm3.66 40.9-.55 37.53 34.22.6-.22-37.54-33.45-.59zm.18-40.88-.55 36.7 33.45.18.16-36.29-33.06-.59zm70.56 41.24.22 37.54-34.23.24.56-37.53 33.45-.25zm.18-40.87.22 36.7-33.44-.17.16-36.29 33.06-.24zM1218 393.06l.23 36.71-33.45-.17.16-36.29 33.06-.25zm38.72-.77.22 36.71-33.44-.18.16-36.28 33.06-.25zm3.84.02-.55 36.7 33.44.18.16-36.29-33.05-.59zm70.73.37.23 36.7-33.45-.17.16-36.29 33.06-.24zm-74.64 41.08.22 37.54-34.23.24.56-37.54 33.45-.24zm3.84.02-.56 37.53 34.22.6-.22-37.54-33.44-.59zm70.73.36.22 37.54-34.22.24.55-37.53 33.45-.25zM1370.22 516.94l.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.23 36.71-33.45-.17.16-36.29 33.06-.25zm.72-41.53.23 37.54-34.23.24.56-37.54 33.44-.24zm37.81 81.64.22 37.54-34.22.24.55-37.54 33.45-.24zm.18-40.88.23 36.71-33.45-.17.16-36.29 33.06-.25zm3.66 40.9-.55 37.53 34.22.6-.22-37.54-33.45-.59zm.19-40.88-.56 36.7 33.45.18.16-36.29-33.05-.59zm70.55 41.24.22 37.54-34.23.24.56-37.53 33.45-.25zm.18-40.87.23 36.7-33.45-.17.16-36.29 33.06-.24zm-112.49-82.62.22 36.71-33.44-.17.16-36.29 33.06-.25zm38.71-.77.22 36.71-33.44-.18.16-36.28 33.06-.25zm3.84.02-.55 36.7 33.44.18.17-36.29-33.06-.59zm70.74.37.22 36.7-33.44-.17.16-36.29 33.06-.24zm-74.65 41.08.22 37.54-34.23.24.56-37.54 33.45-.24zm3.84.02-.56 37.53 34.23.6-.23-37.54-33.44-.59zm70.73.36.23 37.54-34.23.24.56-37.53 33.44-.25zM1523.41 516.94l.22 37.54-34.22.24.55-37.54 33.45-.24zm.18-40.88.23 36.71-33.45-.17.16-36.29 33.06-.25zm.73-41.53.22 37.54-34.23.24.56-37.54 33.45-.24zm37.8 81.64.23 37.54-34.23.24.56-37.54 33.44-.24zm.19-40.88.22 36.71-33.45-.17.17-36.29 33.06-.25zm3.66 40.9-.56 37.53 34.22.6-.22-37.54-33.44-.59zm.18-40.88-.55 36.7 33.44.18.16-36.29-33.05-.59zm70.55 41.24.22 37.54-34.22.24.55-37.53 33.45-.25zm.18-40.87.23 36.7-33.45-.17.16-36.29 33.06-.24zm-112.49-82.62.22 36.71-33.44-.17.16-36.29 33.06-.25zm38.71-.77.23 36.71-33.45-.18.16-36.28 33.06-.25zm3.84.02-.55 36.7 33.45.18.16-36.29-33.06-.59zm70.74.37.22 36.7-33.44-.17.16-36.29 33.06-.24zm-74.65 41.08.22 37.54-34.22.24.55-37.54 33.45-.24zm3.84.02-.55 37.53 34.22.6-.22-37.54-33.45-.59zm70.74.36.22 37.54-34.23.24.56-37.53 33.45-.25zM1676.6 516.94l.23 37.54-34.23.24.56-37.54 33.44-.24zm.19-40.88.22 36.71-33.45-.17.17-36.29 33.06-.25zm.72-41.53.22 37.54-34.22.24.55-37.54 33.45-.24zm37.81 81.64.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.22 36.71-33.44-.17.16-36.29 33.06-.25zm3.66 40.9-.56 37.53 34.22.6-.22-37.54-33.44-.59zm.18-40.88-.55 36.7 33.44.18.17-36.29-33.06-.59zm70.55 41.24.22 37.54-34.22.24.55-37.53 33.45-.25zm.18-40.87.23 36.7-33.45-.17.17-36.29 33.05-.24zm-112.49-82.62.23 36.71-33.45-.17.16-36.29 33.06-.25zm38.71-.77.23 36.71-33.45-.18.16-36.28 33.06-.25zm3.85.02-.56 36.7 33.45.18.16-36.29-33.05-.59zm70.73.37.23 36.7-33.45-.17.16-36.29 33.06-.24zm-74.65 41.08.22 37.54-34.22.24.55-37.54 33.45-.24zm3.84.02-.55 37.53 34.22.6-.22-37.54-33.45-.59zm70.74.36.22 37.54-34.22.24.55-37.53 33.45-.25zM1829.8 516.94l.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.22 36.71-33.44-.17.16-36.29 33.06-.25zm.72-41.53.22 37.54-34.22.24.55-37.54 33.45-.24zm37.81 81.64.22 37.54-34.23.24.56-37.54 33.45-.24zm.18-40.88.23 36.71-33.45-.17.16-36.29 33.06-.25zm3.66 40.9-.56 37.53 34.23.6-.23-37.54-33.44-.59zm.18-40.88-.55 36.7 33.45.18.16-36.29-33.06-.59zm70.56 41.24.22 37.54-34.23.24.56-37.53 33.45-.25zm.18-40.87.22 36.7-33.44-.17.16-36.29 33.06-.24zm-112.5-82.62.23 36.71-33.45-.17.16-36.29 33.06-.25zm38.72-.77.22 36.71-33.44-.18.16-36.28 33.06-.25zm3.84.02-.55 36.7 33.44.18.16-36.29-33.05-.59zm70.73.37.23 36.7-33.45-.17.16-36.29 33.06-.24zm-74.65 41.08.23 37.54-34.23.24.56-37.54 33.44-.24zm3.85.02-.56 37.53 34.22.6-.22-37.54-33.44-.59zm70.73.36.22 37.54-34.22.24.55-37.53 33.45-.25z"
        />
        <path
          style={{
            fill: '#c3c5c7',
          }}
          d="m1385.44 130.54-1.37 236.24-62.18 6.46.52 26.28 248.85-.81v-24.82l-62.83-5.49V132.6l-122.99-2.06z"
        />
        <path
          style={{
            fill: '#56596f',
          }}
          d="m1873.29 333.25 1.21 54.51h13.33v-53.3l-14.54-1.21zm1.8-92.32 1.21 54.5h13.32v-53.29l-14.53-1.21zm-283.12 92.32 1.21 54.51h13.32v-53.3l-14.53-1.21zm1.32-92.32 1.21 54.5h13.33v-53.29l-14.54-1.21z"
        />
        <path
          d="M1622.25 267.86s2.53 6.17 6.32 8.67c5.08 3.34 10.98 7.16 10.98 7.16l91.58-6.72s12.55-6.89 14.73-10.17c2.19-3.28 3.72-7.41 3.72-7.41l-127.33 8.46Z"
          style={{
            fill: '#f8f7f0',
          }}
        />
        <path
          d="M1619.44 277.03s2.11 6.33 5.72 9.07c4.84 3.68 10.47 7.89 10.47 7.89l91.82-.53s12.98-6.02 15.39-9.15c2.4-3.13 4.21-7.14 4.21-7.14l-127.61-.14Z"
          style={{
            fill: '#cfb882',
          }}
        />
        <path
          d="M1617.85 292.1s2.11 6.33 5.72 9.07c4.84 3.68 10.47 7.89 10.47 7.89l91.82-.53s12.98-6.02 15.39-9.15c2.4-3.13 4.21-7.14 4.21-7.14l-127.61-.14Z"
          style={{
            fill: '#2a5151',
          }}
        />
        <path
          d="M1618.64 307.17s2.11 6.33 5.72 9.07c4.84 3.68 10.47 7.89 10.47 7.89l91.82-.53s12.98-6.02 15.39-9.15c2.4-3.13 4.21-7.14 4.21-7.14l-127.61-.14Z"
          style={{
            fill: '#7e897b',
          }}
        />
        <path
          style={{
            fill: '#b7a268',
          }}
          d="m1570.08 335.96 335.21 2.18.54-15.62-336.14-.52.39 13.96z"
        />
        <path
          style={{
            fill: '#565f51',
          }}
          d="M1666.74 554.13h20.85v14.99h-20.85zm182.2 0h20.85v14.99h-20.85z"
        />
        <path
          d="M1868.05 564.32h-220.77c-3.08 0-5.6-2.52-5.6-5.6l.95-123.27c0-3.08 1.57-7.23 4.66-7.23h220.77c3.08 0 5.6 2.52 5.6 5.6v124.9c0 3.08-2.52 5.6-5.6 5.6Z"
          style={{
            fill: '#fbf8f6',
          }}
        />
        <path
          d="M1858.57 502.53c4.07-.36 5.77-3.44 5.46-6.11-.35-3.11-2.4-5.33-6.12-5.23-3.51.1-6.05 3.1-5.24 6.81.66 3.07 2.88 4.8 5.91 4.53Z"
          style={{
            fill: '#0090cb',
          }}
        />
        <path
          d="M1858.57 519.05c4.07-.36 5.77-3.44 5.46-6.11-.35-3.11-2.4-5.33-6.12-5.23-3.51.1-6.05 3.1-5.24 6.81.66 3.07 2.88 4.8 5.91 4.53Z"
          style={{
            fill: '#007581',
          }}
        />
        <path
          style={{
            fill: '#272a3e',
            opacity: 0.75,
          }}
          d="M1687.29 451.59h145.78v88.95h-145.78z"
        />
        <path
          d="M826.71 733.07c-9.58-.99-54.27.81-67.87.69-13.6-.12-19.11 9.99-19.21 22.04 0 .6 0 1.66-.01 3.1l105.32-.87c-.01-12.88-5.71-23.65-18.22-24.95Zm-87.05 30.62c-.05 36.06.06 183.34.06 183.34l106.41.1s-1.72-159.97-1.27-184.34l-105.19.89Z"
          style={{
            fill: '#57c0d5',
          }}
        />
        <path
          d="M844.87 760.5c.04-.83.06-1.66.06-2.47l-105.32.87v5.08l105.19-.89c.02-1.14.05-2.02.08-2.59Z"
          style={{
            fill: '#7ecbdf',
          }}
        />
        <path
          style={{
            fill: '#5a5964',
          }}
          d="m771.84 934.42-5.18 24.33 44.09.54-3.66-23.95-35.25-.92z"
        />
        <path
          d="M186.19 267.94c-21.74 0-41.68-8.22-56.15-23.14-13.54-13.97-20.67-32.34-20.07-51.72.6-19.56 7.8-37.34 20.26-50.07 13.55-13.83 32.48-21.14 54.75-21.14.53 0 1.06 0 1.59.01 47.24.73 72.99 36.22 74 70.91.56 19.3-7.01 38.51-20.78 52.69-14.07 14.48-33.1 22.46-53.6 22.46Z"
          style={{
            fill: '#a3ceeb',
          }}
        />
        <path
          d="M184.98 124.65c.51 0 1.03 0 1.55.01 44.12.68 70.25 33.26 71.27 68.21 1.1 37.66-29.53 72.29-71.61 72.29s-74.68-32.26-73.45-72c1.15-37.21 26.7-68.52 72.24-68.52m0-5.54c-23.03 0-42.65 7.6-56.73 21.97-12.95 13.22-20.43 31.66-21.05 51.92-.62 20.14 6.78 39.22 20.85 53.73 14.99 15.46 35.64 23.98 58.14 23.98 21.25 0 40.99-8.27 55.59-23.3 14.29-14.71 22.15-34.65 21.57-54.7-.56-19.21-8.03-37.2-21.03-50.65-14.17-14.67-33.43-22.6-55.7-22.95-.55 0-1.09-.01-1.64-.01Z"
          style={{
            fill: '#fcf6e7',
          }}
        />
        <path
          d="M186.46 209.09c-.82.09-1.51-.5-1.52-1.33 0 0-1.7-61.66-1.61-62.66.13-1.48.2-2.54 1.7-2.84 1.51-.31 2.34.57 2.47 2.01.13 1.44 5.75 62.95 5.75 62.95.07.82-.55 1.57-1.37 1.66l-5.42.21Z"
          style={{
            fill: '#272a3e',
          }}
        />
        <path
          d="M152.36 214.36c.37.73 1.3 1.08 2.06.76l44.43-18.45c.76-.32 1.05-1.16.64-1.88l-2.12-5.7c-.41-.72-1.33-.97-2.05-.57l-42.87 22.71c-.72.4-1 1.32-.63 2.06l.54 1.07Z"
          style={{
            fill: '#272a3e',
          }}
        />
        <path
          d="M1858.29 104.74s.19 2.01.39 3.88 3.8 4.33 7.95 7.1c4.16 2.77 6.56 6.32 6.84 9.48.28 3.16.16 44.61-.08 55.75s-.36 37.58.08 43.32c.44 5.74-2.63 7.17-5.62 7.02-3-.14-31.93.79-38.63.47-6.7-.32-5.65-4.42-5.79-7.57-.14-3.15.09-31.76-.1-42.78s.52-43.87 1.86-50.95c1.34-7.08 10.06-16.11 12.63-18.99 2.57-2.88 1.91-4.06 1.91-4.06l18.57-2.69Zm-.46 18.56c-.74.8-.63 7.12-.86 15.11-.24 8-.72 15.12.75 17.34 1.47 2.21 7.9 2.23 8.9-.86 1.01-3.1.58-9.12.72-15.12s.87-12.25-1.27-15.36c-2.14-3.1-6.58-2.89-8.24-1.11Z"
          style={{
            fill: '#4c8f44',
          }}
        />
        <g
          style={{
            clipPath: 'url(#kitchen4-b)',
          }}
        >
          <path
            style={{
              fill: '#006443',
            }}
            d="M1818.67 144.01h60.36l-1.28 48.55-59.85-.52.77-48.03z"
          />
        </g>
        <path
          d="M1841.15 103.25c-1.29.05-2.33.21-2.37 1.92-.04 1.72-.37 3.62.13 3.96s20.16.2 20.77.03c.57-.16.3-2.85.27-3.89-.03-1.04-.19-1.68-1.66-1.83-1.55-.16-15.77-.25-17.14-.2Z"
          style={{
            fill: '#2e425b',
          }}
        />
        <path
          style={{
            fill: '#b7a268',
          }}
          d="m1572.16 243.02 333.63 2.64-.01-13.74-334-2.85.38 13.95z"
        />
        <path
          d="M1133.48 538.28h-1.49l-.27-33.27-4.12-.59.27 33.86h-6.75v-10.01h-3.7c.29-16.86.72-46.22.37-51.81-.33-5.35-1.24-12.35-5.29-19.04-4.83-7.97-12.96-13.38-24.15-16.08-6.93-1.67-13.44-1.02-19.35 1.94-4.59 2.3-8.73 5.98-12.31 10.92-5.84 8.07-8.24 16.86-8.34 17.23l8.93 2.4c.02-.08 2.13-7.7 7.03-14.38 6.03-8.23 13.19-11.21 21.87-9.12 8.83 2.13 14.85 6.02 18.41 11.89 3.01 4.96 3.7 10.52 3.97 14.82.3 4.87-.05 31.33-.39 51.24h-5.3c0-.59.59 40.34.59 40.34h17.67v-10.7l10.6-.19s7.95-.29 8.24-9.42c.29-9.13-6.48-10.01-6.48-10.01Z"
          style={{
            fill: '#51566d',
          }}
        />
        <path
          style={{
            fill: '#51566d',
          }}
          d="m848.2 586.05 1417.68 8.06-.38-23.41-1416.75-8.49-.55 23.84z"
        />
      </g>
    </svg>
  )}

export default Kitchen4
